// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QpPfztHkL6gyYf5t7G6F{justify-content:space-between;align-items:baseline;gap:4px;display:inline-flex}.POQazch_T8g3lFNOsJ8k>div:nth-of-type(2){max-height:inherit}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleWithBadge": `QpPfztHkL6gyYf5t7G6F`,
	"blockFields": `POQazch_T8g3lFNOsJ8k`
};
export default ___CSS_LOADER_EXPORT___;
